import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    padding: theme.spacing(4),
  },
  headerRoot: {
    paddingBottom: 32,
  },
  header: {
    fontWeight: 'bold',
  },
  content: {
    padding: 40,
    maxWidth: 400,
    minHeight: 620,
    display: 'flex',
    borderRadius: 20,
    flexDirection: 'column',
    backgroundColor: theme.palette.dark,
    marginTop: 16,
  },
  note: {
    marginTop: 20,
  },
  noteText: {
    textAlign: 'justify',
    fontSize: 12,
    color: theme.palette.secondary.main,
  },
  lightButton: {
    minWidth: '100%',
    border: 'solid 2px #fff',
    borderRadius: 10,
    marginTop: 16,
    padding: '8px 0',
    fontSize: 16,
    fontWeight: 'bolder',
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.dark,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover svg': {
      position: 'relative',
      animationName: '$slide',
      animationDuration: '0.8s',
      animationTimingFunction: 'linear',
      animationIterationCount: '8',
    },
  },
  '@keyframes slide': {
    '0%, 100%': { left: 0 },
    '50%': { left: 4 },
  },
  max: {
    color: theme.palette.secondary.dark,
  },
  balance: {
    fontSize: 14,
    marginTop: 8,
    marginBottom: 12,
    alignSelf: 'flex-end',
  },
  balanceValue: {
    color: '#bc9c1b',
  },
  chipBalanceValue: {
    color: '#b182ff',
  },
  pkr: {
    padding: '10px 12px',
    fontWeight: 'bold',
    backgroundColor: theme.palette.background.default,
    color: 'rgba(194, 195, 197, 0.65)',
    textAlign: 'center',
    lineHeight: 2,
    borderRadius: 10,
  },
  chips: {
    padding: '10px 16px',
    fontWeight: 'bold',
    backgroundColor: theme.palette.background.default,
    color: 'rgba(194, 195, 197, 0.65)',
    textAlign: 'center',
    lineHeight: 2,
    borderRadius: 10,
  },
  splitter: {
    color: theme.palette.secondary.dark,
  },
  inputRoot: {
    display: 'flex',
    minWidth: 60,
    borderRadius: 10,
    alignItems: 'center',
    paddingLeft: 16,
    backgroundColor: theme.palette.background.default,
  },
  input: {
    flex: 1,
    margin: '8px 0',
  },
  arrowIcon: {
    width: 30,
    height: 30,
    padding: 2,
    margin: '16px 0',
    textAlign: 'center',
    borderRadius: '50%',
    alignSelf: 'center',
    border: `1px solid ${theme.palette.primary.main}`,
  },
  button: {
    marginTop: 16,
    fontSize: 16,
    padding: '8px 0',
    fontWeight: 'bold',
    backgroundColor: theme.palette.primary.main,
  },
  hash: {
    marginTop: 16,
    fontSize: 12,
  },
  connectedWallet: {
    color: theme.palette.secondary.dark,
    marginTop: 32,
  },
  inputLabel: {
    color: theme.palette.secondary.dark,
  },
  balanceRoot: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    marginTop: 32,
    minWidth: 633,
    justifyContent: 'center',
    textAlign: 'center',
  },
  balanceHeader: {
    marginBottom: 18,
  },
  circle: {
    height: 275,
    width: 275,
    borderRadius: 200,
    border: 'solid 2px #fff',
    margin: '0px auto',
    color: theme.palette.secondary.main,
    position: 'relative',
  },
  circleContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    margin: 'auto',
  },
  line: {
    maxWidth: 56,
    height: 60,
    borderBottom: '1px solid #fff',
    margin: 'auto',
  },
  dealHeader: {
    marginTop: 14,
    marginRight: -10.8,
    letterSpacing: 10.8,
    fontSize: 18,
    color: theme.palette.secondary.dark,
  },
  dealsContainer: {
    margin: '24px auto',
    width: 633,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dealsCard: {
    backgroundColor: theme.palette.dark,
    height: 216,
    width: 200,
    borderRadius: 15,
    padding: '20px 30px',
  },
  chipValue: {
    color: theme.palette.primary.main,
    fontSize: 50,
    fontWeight: 'bold',
  },
  chipText: {
    color: theme.palette.primary.main,
  },
  walletRoot: {
    flex: 1,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 440,
  },
}));

export default useStyles;
